import { render, staticRenderFns } from "./promotional-code.vue?vue&type=template&id=3a5ed306&"
import script from "./promotional-code.vue?vue&type=script&lang=ts&"
export * from "./promotional-code.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports